import { Controller } from 'stimulus';

/**
 *  Show shipping address form
 *
 * @class Address
 * @extends {Controller}
 */
class Address extends Controller {
  connect() {
    this.belgiumCountries = this.countryTargets.filter((country) => country.value === '2');
    this.country = this.belgiumCountries?.length ? 'BE' : 'NL';

    if (!this.hasShippingAddressFieldsTarget) return;

    this.toggleShippingAddressFields();
    this.onCompanyNameInput();
  }

  toggleShippingAddressFields() {
    const isChecked = this.shippingAddressTogglerTarget.checked;

    $(this.shippingAddressFieldsTarget).toggle(isChecked);
    $(this.shippingAddressFieldsTarget).find('[data-required]').prop('required', isChecked);
  }

  onCompanyNameInput() {
    const isRequired = this.companyNameTarget.value.length > 0;

    this.toggleRequiredOnField(this.vatNumberTarget, isRequired);
    this.toggleRequiredOnField(this.cocNumberTarget, isRequired && this.country !== 'BE');
  }

  onCountryChange({ currentTarget }) {
    this.country = currentTarget.value === '2' ? 'BE' : 'NL';

    this.onCompanyNameInput();
  }

  toggleRequiredOnField(field, isRequired = false) {
    field[isRequired ? 'setAttribute' : 'removeAttribute']('required', isRequired);

    this.toggleRequiredOnLabel(field.previousElementSibling, isRequired);
  }

  toggleRequiredOnLabel(label, isRequired = false) {
    if (!label || label.tagName !== 'LABEL') return;

    if (label.innerText.includes('*')) {
      label.innerText = label.innerText.replace('*', '');
    }

    label.innerText += isRequired ? '*' : '';
  }
}

Address.targets = [
  'shippingAddressToggler',
  'shippingAddressFields',
  'companyName',
  'vatNumber',
  'cocNumber',
  'country',
];

export default Address;
